var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcAvatarLive = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 11,
  fill: "none",
  viewBox: "0 0 24 11",
  ref: ref
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#svg-1179475244__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22.572,
  height: 10.4,
  x: 0.714,
  y: 0.137,
  fill: "url(#svg-1179475244__b)",
  rx: 5.2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.18 7.9h3.515V6.867H5.257v-4.13H4.18zM8.556 7.9h1.076V2.737H8.556zM12.413 7.937h.95l1.977-5.2h-1.16l-1.278 3.636-1.279-3.636h-1.188zM16.095 7.9h3.725V6.89h-2.656V5.804h2.306v-1.01h-2.306V3.747h2.62v-1.01h-3.689z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-1179475244__b",
  x1: 0.714,
  x2: 6.73,
  y1: 0.137,
  y2: 16.59,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF465D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F711BA"
})), /*#__PURE__*/React.createElement("filter", {
  id: "svg-1179475244__a",
  width: 27.079,
  height: 14.907,
  x: -1.539,
  y: -2.116,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 1.127
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_8483_3921"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_8483_3921",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcAvatarLive);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };